
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { ConstructionContractInfoBus } from '@app/cp/shared/models/ConstructionContractInfoBus';
import { ConstructionSearchParam } from '@app/cp/shared/models/ConstructionSearchParam';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { DataStateChangeEvent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { GItem } from '@app/cp/shared/models/GItem';
import { process, aggregateBy, CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { MSCLFilterClass } from '../../shared/classes/filters/MSCLFilterClass';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { DQOIItem } from '../../shared/models/DQOIItem';
import { SearchTarget } from '../../shared/enums/SearchTarget';
import { DQOIMessage } from '../../shared/models/DQOIMessage';
import { MessageType } from '../../shared/enums/MessageType';
import { animate, group, style, transition, trigger, state } from "@angular/animations";
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { DQOIService } from '../../shared/services/DQOI.service';
import { BaseDQOIComponent } from '../../shared/base-components/base-dqoi.component';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

interface ColumnSetting {
    field: string;
    title: string;
    format?: string;
    type: 'text' | 'numeric' | 'boolean' | 'date';
    hidden: boolean;

}

@UseCPLoader()
@UseFeatureFlagSet()
@Component({
    selector: 'contract-information',
    templateUrl: './contract-information.component.html',
    styleUrls: ['./contract-information.component.scss'],
    animations: [
        trigger('slideInOut', [
            state('in', style({ height: '*', opacity: 0 })),
            transition(':leave', [
                style({ height: '*', opacity: 1 }),

                group([
                    animate(300, style({ height: 0 })),
                    animate('200ms ease-in-out', style({ 'opacity': '0' }))
                ])

            ]),
            transition(':enter', [
                style({ height: '0', opacity: 0 }),

                group([
                    animate(300, style({ height: '*' })),
                    animate('400ms ease-in-out', style({ 'opacity': '1' }))
                ])

            ])
        ])
    ],
    encapsulation: ViewEncapsulation.None
})
export class ConstructionContractInformationComponent extends BaseGridComponent<ConstructionContractInfoBus, null> implements OnInit, OnDestroy {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    compLoader: ICPLoader = this as any;
    public aggregates: any[] = [];
    public aggregateResults;
    public gridView: GridDataResult;
    public pageSize = 26;
    dqoiItem: DQOIItem = null;
    customerNameCF: MSCLFilterClass;
    contractAdministratorCF: MSCLFilterClass;
    locationNameCF: MSCLFilterClass;
    pmCF: MSCLFilterClass;
    divisionNameCF: MSCLFilterClass;
    public expandedGroupKeys: any[] = [];
    selectedKeys: any[] = [];
    updatedContractInfo = false;

    // Scroll persistence (simplified)
    private gridContentEl: HTMLElement | null = null;
    private lastScrollTop = 0;
    // ------------------------

    private _splitterSize: string = localStorage.getItem("sidebarSize") || "35%";

    constructor(public cdr: ChangeDetectorRef, globals: GlobalsService, featureFlagService: FeatureFlagService, private qry_rd: DQOIReferenceDataQuery, svc_data: ConstructionService, private svc_dqoi: DQOIService) {

        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
        this.svc_data = svc_data;

        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();

        this.aggregates = [
            { field: 'dispatchNumber', aggregate: 'count' },
            { field: 'contractAmount', aggregate: 'sum' },
            { field: 'estimatedCost', aggregate: 'sum' },
            { field: 'totalCostPlusTax', aggregate: 'sum' },
            { field: 'profitDollars', aggregate: 'sum' },
            { field: 'billedAmount', aggregate: 'sum' },
            { field: 'openAmount', aggregate: 'sum' },
            { field: 'unbilledAmount', aggregate: 'sum' },
            { field: 'receivedAmount', aggregate: 'sum' },
            { field: 'btmAmount', aggregate: 'sum' },
            { field: 'profitPercentage', aggregate: 'sum' },
            { field: 'contractProfitDollars', aggregate: 'sum' },
            { field: 'pendingChangeRequests', aggregate: 'sum' },
            { field: 'costsSinceLastDraw', aggregate: 'sum' },
            { field: 'pendingATPChangeRequests', aggregate: 'sum' },
        ];
    }
    subs_dataRef: Subscription;
    svc_data: ConstructionService;
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }

    contractAdministratorId: any;
    lastReturn: any[] = [];
    gridDataPrime: any[] = [];

    get hasReferenceData(): boolean {
        let retVal: boolean = false;
        try {
            retVal = this.referenceData !== undefined && this.referenceData !== null && this.referenceData.dispatchStatus !== undefined && this.referenceData.dispatchStatus !== null ? true : false;
        }
        catch {
            retVal = false;
        }
        return retVal;

    }

    //customerId: any;
    //jobClassIds: any;
    //dispatchStatusIds: any;
    constractNo: string;
    billingMonthYear: any;
    projectManagerId: any;

    //Filters
    contractAdministrator: GItem[] = [];
    contractStatuses: GItem[] = [];
    customers: GItem[] = [];
    jobClasses: GItem[] = [];

    contractAdministratorIds: GItem[] = [];
    dispatchStatusIds: GItem[] = [];
    customerIds: GItem[] = [];
    jobClassIds: GItem[] = [];

    filteredData: any[];
    exportFilteredData: any[];

    ColumnHeaders: ColumnSetting[];
    StaticColumnHeaders: ColumnSetting[];
    DynamicColumnHeaders: ColumnSetting[];
    loading: boolean = true;
    private initSubscription: Subscription;
    private getDataSubscription: Subscription;

    openContractInfoTimeStamp: number;

    ngOnInit() {
        this.loading = true;
        this.openContractInfoTimeStamp = this.svc_data.openContractInfoTimeStamp;
        this.initSubscription = this.svc_data.openContractInfoData$.subscribe(data => {
            if (data && data.primaryReturn && data.primaryReturn.length > 0) {
                this.handleData(data);
            } else {
                //Temporarily disable auto-refresh when no data is returned
                //this.getData();
                this.loading = false;
            }
        });
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.unsubscribeAll();
        CommonFunctions.unsubscribe(this.subs_dataRef);
        if (this.gridContentEl) {
            this.gridContentEl.removeEventListener('scroll', this.onGridScroll);
        }
    }

    // --- Scroll Helpers ---
    private getGridContentEl(): HTMLElement | null {
        const host = (this.grid as any)?.wrapper?.nativeElement as HTMLElement;
        return host ? host.querySelector('.k-grid-content') : null;
    }
    private onGridScroll = (e: Event) => {
        const el = e.target as HTMLElement;
        this.lastScrollTop = el.scrollTop;
    };
    private captureScroll(): void {
        if (this.gridContentEl) this.lastScrollTop = this.gridContentEl.scrollTop;
    }
    private restoreScroll(): void {
        if (!this.gridContentEl) this.gridContentEl = this.getGridContentEl();
        if (!this.gridContentEl) return;
        requestAnimationFrame(() => {
            this.gridContentEl!.scrollTop = this.lastScrollTop;
        });
    }

    public restoreScrollPosition(): void {
        this.restoreScroll();
    }

    public onSelectionChange(event: any): void {
        this.selectedKeys = event.selectedRows.map((row: any) => row.dataItem.id);
    }

    public onDataStateChange(state: DataStateChangeEvent): void {
        this.state = state;
    }

    getData() {
        console.log('opencontrinfo->getData');
        let param: ConstructionSearchParam = this.getParam();
        this.svc_data.getDynamicOpenContractInfo(param);
    }
    getSingleData(contractId: any) {

        let param: ConstructionSearchParam = this.getParam();
        param.contractId = contractId;
        this.svc_data.getSingleDynamicOpenContractInfo(param);
        this.updatedContractInfo = true;
    }
    clearData() {
        this.dqoiItem = null;
        this.filteredData = [];
        this.loading = true;
        this.updatedContractInfo = false;
    }

    refreshData() {
        // Reset the state to force the grid to load from the beginning
        this.state.skip = 0;
        this.clearData();
        this.getData();
        this.cdr.detectChanges();
    }

    unsubscribeAll() {

        if (this.initSubscription) {
            this.initSubscription.unsubscribe();
        }
        if (this.getDataSubscription) {
            this.getDataSubscription.unsubscribe();
        }
    }

    handleData(data: any) {
        if (!this.updatedContractInfo) {
            if (data && data.primaryReturn && data.primaryReturn.length > 0) {

                this.lastReturn = data.primaryReturn;
                let newAggregates = this.populateDynamicAggregates(data.primaryReturn);
                this.aggregates = this.aggregates.concat(newAggregates);
                this.gridDataPrime = this.processDynamicDataForGrid(data.primaryReturn);
                this.applyFilters();
                this.setColumnHiddenStatus();
                this.loading = false;
                this.svc_data.openContractInfoTimeStamp = Date.now();
                this.openContractInfoTimeStamp = Date.now();
            } else if (data && data.primaryReturn && data.primaryReturn.length == 0) {

                this.loading = false;
                this.globals.notifyError('There was a problem getting data, retrying...');
            } else {

                this.loading = false;
                this.globals.notifyError('There was a problem getting data, retrying...');
            }
        }
        this.restoreScroll();
    }

    processGridData() {
        this.exportFilteredData = filterBy(this.filteredData, this.filter);
        if (CommonFunctions.hasArrayElementValue(this.exportFilteredData)) {
            this.aggregateResults = aggregateBy(this.exportFilteredData, this.aggregates);

        }
        else {
            this.aggregateResults = {};
        }

        this.customerNameCF = new MSCLFilterClass('customerName', 'customerName', this.filteredData);
        this.contractAdministratorCF = new MSCLFilterClass('contractAdministrator', 'contractAdministrator', this.filteredData);
        this.locationNameCF = new MSCLFilterClass('locationName', 'locationName', this.filteredData);
        this.divisionNameCF = new MSCLFilterClass('divisionName', 'divisionName', this.filteredData);
        this.pmCF = new MSCLFilterClass('pm', 'pm', this.filteredData);

        this.loading = false;
    }

    public pageChange(event: PageChangeEvent): void {
        this.skip = event.skip;
        this.loadProducts();
    }

    private loadProducts(): void {
        this.gridView = {
            data: this.filteredData.slice(this.skip, this.skip + this.pageSize),
            total: this.filteredData.length
        };
    }

    getParam(initial: boolean = false): ConstructionSearchParam {
        let param: ConstructionSearchParam = new ConstructionSearchParam();

        if (!initial) {
            param.userId = this.globals.userId;
            param.companyId = this.globals.companyId;
            param.contractAdministratorId = this.contractAdministratorId;
            //param.customerId = this.customerId;
            param.jobClassIds = this.jobClassIds; // CommonFunctions.getArrayFromCommaDelimitedString(this.jobClassIds);
            param.dispatchStatusIds = this.dispatchStatusIds; // CommonFunctions.getArrayFromCommaDelimitedString(this.dispatchStatusIds);
            param.contractNo = this.constractNo;
            if (this.billingMonthYear != null) {
                param.billingMonthYear = this.billingMonthYear;
            } else {
                param.billingMonthYear = new Date();
                param.billingMonthYear.setDate(1);
            }
        }
        return param;
    }
    apiFilter() {
        this.getData();
    }

    applyFilters() {
        this.captureScroll();
        this.loading = true;
        this.filteredData = [];
        if (this.contractAdministratorIds.length == 0 && this.dispatchStatusIds.length == 0 && this.customerIds.length == 0 && this.jobClassIds.length == 0) {
            this.filteredData = _.cloneDeep(this.gridDataPrime);
        } else {
            let tempFilteredData = _.cloneDeep(this.gridDataPrime);
            if (this.contractAdministratorIds.length > 0) {
                tempFilteredData.forEach(row => {
                    let filterIndex = this.contractAdministratorIds.findIndex((element) => { return element === row.contractAdminId; });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.contractId === row.contractId; }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }

            if (this.dispatchStatusIds.length > 0) {
                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridDataPrime);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.dispatchStatusIds.findIndex((element) => { return element === row.dispatchStatusId; });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.contractId === row.contractId; }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }

            if (this.customerIds.length > 0) {
                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridDataPrime);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.customerIds.findIndex((element) => { return element === row.customerId; });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.contractId === row.contractId; }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }

            if (this.jobClassIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridDataPrime);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.jobClassIds.findIndex((element) => { return element === row.accountClassId; });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.contractId === row.contractId; }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
        }
        this.processGridData();
        this.restoreScroll();
    }

    clearFilters() {
        this.loading = true;
        this.filteredData = [];
        this.contractAdministratorIds = [];
        this.dispatchStatusIds = [];
        this.customerIds = [];
        this.jobClassIds = [];
        //this.applyFilters();
        this.clearData();
        this.loading = false;
    }

    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }

    processDynamicDataForGrid(data: any) {
        let pivoted = this.pivotData(data);
        pivoted = this.PopulateZeros(pivoted);
        this.PopulateFilters(pivoted);

        this.ColumnHeaders = this.getColumnHeaders(pivoted);
        this.StaticColumnHeaders = this.getStaticColumnHeaders(this.ColumnHeaders);
        this.DynamicColumnHeaders = this.getDynamicColumnHeaders(this.ColumnHeaders);

        //let sorted = this.SortDynamicColumns(this.ColumnHeaders);
        //this.ColumnHeaders = sorted;
        //let dateFormated = this.updateDateData(sorted);

        return pivoted;
    } jobWarrantyEndDate;

    pivotData(data) {
        //let test = [];
        var iter = function (pivoted, record) {
            //test.push(pivoted.find((element) => { return element.dispatchId == record.dispatchId }));
            let index = pivoted.findIndex((element) => { return element.contractId === record.contractId; });
            if (index > -1 && record.columnTypeTitle && record.columnTypeTitle != '') {
                //pivoted[index][record.columnTypeTitle] = record.columnValue;
                pivoted[index][(record.relatedJobType ? record.relatedJobType.substring(0, 3) + '' : '') + (record.columnType ? record.columnType : '')] = record.columnValue;
            } else if (record.columnTypeTitle && record.columnTypeTitle != '') {
                pivoted.push({
                    contractId: record.contractId,
                    [(record.relatedJobType ? record.relatedJobType.substring(0, 3) + '' : '') + (record.columnType ? record.columnType : '')]: record.columnValue,
                    customerId: record.customerId,
                    customerName: record.customerName,
                    locationName: record.locationName,
                    locationId: record.locationId,
                    dispatchNumber: record.dispatchNumber,
                    receivedDateTime: record.receivedDateTime,
                    estimatedEndDate: record.estimatedEndDate,
                    estimatedBeginDate: record.estimatedBeginDate,
                    jobWarrantyEndDate: record.jobWarrantyEndDate,
                    lastDayLaborStartDate: record.lastDayLaborStartDate,
                    poNumber: record.poNumber,
                    contractAmount: record.contractAmount,
                    billedAmount: record.billedAmount,
                    openAmount: record.openAmount,
                    unbilledAmount: record.unbilledAmount,
                    receivedAmount: record.receivedAmount,
                    btmAmount: record.btmAmount,
                    contractNote: record.contractNote,
                    contractAdminId: record.contractAdminId,
                    contractAdministrator: record.contractAdministrator,
                    dispatchStatusId: record.dispatchStatusId,
                    dispatchStatusName: record.dispatchStatusName,
                    accountClassId: record.accountClassId,
                    accountClassName: record.accountClassName,
                    certPayrollRequired: record.certPayrollRequired,
                    drawDateInfo: record.drawDateInfo,
                    dispatchReason: record.dispatchReason,
                    profitDollars: record.profitDollars,
                    profitPercentage: record.profitPercentage,
                    mostRecentDrawCost: record.mostRecentDrawCost,
                    divisionName: record.divisionName,
                    co: record.co,
                    pm: record.pm,
                    totalCostPlusTax: record.totalCostPlusTax,
                    contractProfitDollars: record.contractProfitDollars,
                    contractProfitPerc: record.contractProfitPerc,
                    pendingChangeRequests: record.pendingChangeRequests,
                    costsSinceLastDraw: record.costsSinceLastDraw,
                    pmid: record.pmid,
                    dynamicContractCostId: record.dynamicContractCostId,
                    dateExecuted: record.dateExecuted,
                    pendingATPChangeRequests: record.pendingATPChangeRequests
                });
            } else {
                pivoted.push({
                    contractId: record.contractId,
                    customerId: record.customerId,
                    customerName: record.customerName,
                    locationName: record.locationName,
                    locationId: record.locationId,
                    dispatchNumber: record.dispatchNumber,
                    receivedDateTime: record.receivedDateTime,
                    estimatedEndDate: record.estimatedEndDate,
                    estimatedBeginDate: record.estimatedBeginDate,
                    jobWarrantyEndDate: record.jobWarrantyEndDate,
                    lastDayLaborStartDate: record.lastDayLaborStartDate,
                    poNumber: record.poNumber,
                    contractAmount: record.contractAmount,
                    billedAmount: record.billedAmount,
                    openAmount: record.openAmount,
                    unbilledAmount: record.unbilledAmount,
                    receivedAmount: record.receivedAmount,
                    btmAmount: record.btmAmount,
                    contractNote: record.contractNote,
                    contractAdminId: record.contractAdminId,
                    contractAdministrator: record.contractAdministrator,
                    dispatchStatusId: record.dispatchStatusId,
                    dispatchStatusName: record.dispatchStatusName,
                    accountClassId: record.accountClassId,
                    accountClassName: record.accountClassName,
                    certPayrollRequired: record.certPayrollRequired,
                    drawDateInfo: record.drawDateInfo,
                    dispatchReason: record.dispatchReason,
                    profitDollars: record.profitDollars,
                    profitPercentage: record.profitPercentage,
                    mostRecentDrawCost: record.mostRecentDrawCost,
                    divisionName: record.divisionName,
                    co: record.co,
                    pm: record.pm,
                    totalCostPlusTax: record.totalCostPlusTax,
                    contractProfitDollars: record.contractProfitDollars,
                    contractProfitPerc: record.contractProfitPerc,
                    pendingChangeRequests: record.pendingChangeRequests,
                    costsSinceLastDraw: record.costsSinceLastDraw,
                    pmid: record.pmid,
                    dynamicContractCostId: record.dynamicContractCostId,
                    dateExecuted: record.dateExecuted,
                    pendingATPChangeRequests: record.pendingATPChangeRequests
                });
            }

            //Cycles
            //Draws
            //UnpaidCycles
            //DispatchStatusName
            //DynamicContractCostId

            return pivoted;
        };

        return data.reduce(iter, []);
    }

    populateDynamicAggregates(data) {
        var iter = function (dynAggregates, record) {
            let fieldName = '';
            if (record.columnTypeTitle && record.columnTypeTitle != '') {
                fieldName = (record.relatedJobType ? record.relatedJobType.substring(0, 3) + '' : '') + (record.columnType ? record.columnType : '');
                let index = dynAggregates.findIndex((element) => { return element.field === fieldName; });
                if (index > -1) {
                    dynAggregates = dynAggregates;
                } else if (record.columnTypeTitle && record.columnTypeTitle != '') {
                    let newFieldName = (record.relatedJobType ? record.relatedJobType.substring(0, 3) + '' : '') + (record.columnType ? record.columnType : '');
                    dynAggregates.push({
                        field: newFieldName,
                        aggregate: 'sum'
                    }
                        //[(record.relatedJobType ? record.relatedJobType.substring(0, 3) + ' ' : '') + (record.columnTypeTitle ? record.columnTypeTitle : '')]: record.columnValue,
                    );
                }
            }

            return dynAggregates;
        };

        return data.reduce(iter, []);

        //            { field: 'profitDollars', aggregate: 'sum' },

    }

    public PopulateFilters(data: any) {
        data.forEach(item => {
            if (this.contractAdministrator.findIndex((element) => { return element.value === item.contractAdminId; }) == -1) {
                this.contractAdministrator.push({ description: item.contractAdministrator, value: item.contractAdminId, category: null, "reference": null });
            }
            if (this.contractStatuses.findIndex((element) => { return element.value === item.dispatchStatusId; }) == -1) {
                this.contractStatuses.push({ description: item.dispatchStatusName, value: item.dispatchStatusId, category: null, "reference": null });
            }
            if (this.customers.findIndex((element) => { return element.value === item.customerId; }) == -1) {
                this.customers.push({ description: item.customerName, value: item.customerId, category: null, "reference": null });
            }
            if (this.jobClasses.findIndex((element) => { return element.value === item.accountClassId; }) == -1) {
                this.jobClasses.push({ description: item.accountClassName, value: item.accountClassId, category: null, "reference": null });
            }
        });

    }

    public getColumnHeaders(data) {
        var iter = function (columns, record) {
            let keys = Object.keys(record);
            keys.forEach((key) => {

                if (columns.findIndex((column) => { return column.field === key; }) == -1) {

                    let columnSettings: ColumnSetting = {
                        field: key,
                        title: key,
                        format: 'c2',
                        type: 'text',
                        hidden: false
                    };
                    columns.push(columnSettings);
                }
            });

            return columns;
        };

        return data.reduce(iter, []);
    }

    public getStaticColumnHeaders(data) {
        var iter = function (columns, record) {
            let staticColumns: any = ['contractId', 'customerId', 'customerName', 'locationName', 'locationId', 'dispatchNumber', 'receivedDateTime', 'estimatedEndDate', 'estimatedBeginDate', 'jobWarrantyEndDate', 'lastDayLaborStartDate', 'poNumber',
                'contractAmount', 'billedAmount', 'openAmount', 'unbilledAmount', 'receivedAmount', 'btmAmount', 'contractNote', 'contractAdminId', 'contractAdministrator', 'dispatchStatusId',
                'dispatchStatusName', 'accountClassId', 'accountClassName', 'certPayrollRequired', 'drawDateInfo', 'dispatchReason', 'profitDollars', 'profitPercentage', 'mostRecentDrawCost',
                'divisionName', 'co', 'pm', 'totalCostPlusTax', 'contractProfitDollars', 'contractProfitPerc', 'pendingChangeRequests', 'pendingATPChangeRequests', 'costsSinceLastDraw', 'pmid', 'dynamicContractCostId', 'dateExecuted'];
            if (columns.findIndex((column) => { return column.field === record.field; }) == -1 && staticColumns.findIndex((entry) => { return entry === record.field; }) != -1) {

                let columnSettings: ColumnSetting = {
                    field: record.field,
                    title: record.field,
                    format: 'c2',
                    type: 'text',
                    hidden: false
                };
                columns.push(columnSettings);
            }
            return columns;
        };

        return data.reduce(iter, []);
    }

    public getDynamicColumnHeaders(data) {
        var iter = function (columns, record) {
            let staticColumns: any = ['contractId', 'customerId', 'customerName', 'locationName', 'locationId', 'dispatchNumber', 'receivedDateTime', 'estimatedEndDate', 'estimatedBeginDate', 'jobWarrantyEndDate', 'lastDayLaborStartDate', 'poNumber',
                'contractAmount', 'billedAmount', 'openAmount', 'unbilledAmount', 'receivedAmount', 'btmAmount', 'contractNote', 'contractAdminId', 'contractAdministrator', 'dispatchStatusId',
                'dispatchStatusName', 'accountClassId', 'accountClassName', 'certPayrollRequired', 'drawDateInfo', 'dispatchReason', 'profitDollars', 'profitPercentage', 'mostRecentDrawCost',
                'divisionName', 'co', 'pm', 'totalCostPlusTax', 'contractProfitDollars', 'contractProfitPerc', 'pendingChangeRequests', 'pendingATPChangeRequests', 'costsSinceLastDraw', 'pmid', 'dynamicContractCostId', 'dateExecuted'];
            if (columns.findIndex((column) => { return column.field === record.field; }) == -1 && staticColumns.findIndex((entry) => { return entry === record.field; }) == -1) {

                let columnSettings: ColumnSetting = {
                    field: record.field,
                    title: record.field,
                    format: 'c2',
                    type: 'text',
                    hidden: false
                };
                columns.push(columnSettings);
            }
            return columns;
        };

        return data.reduce(iter, []);
    }

    SortDynamicColumns(data) {
        let sorted = data;
        return sorted;
    }
    getContract(id) {
        this.captureScroll();
        if (this.dqoiItem && this.dqoiItem.contractId && this.dqoiItem.contractId == id) {
            //this.dqoiItem = null;
            this.compLoader.cpLoader = false;
            this.restoreScrollPosition();
        }
        else {
            this.compLoader.cpLoader = true;
            let param: string = '1:' + id;
            this.dqoiItem = null;
            this.svc_data.getDQOIItem(param).subscribe((info: BaseMessageInfo) => {
                let item: DQOIItem = info.primaryReturn as DQOIItem;
                item.searchTarget = SearchTarget.contract;
                let dataObj: DQOIItem = this.svc_dqoi.addDQOIItem(item);
                this.compLoader.cpLoader = false;
                this.dqoiItem = dataObj;
                this.restoreScrollPosition();
            });
        }

        //this.grid.
    }

    onDQOIMessage(e: DQOIMessage) {
        if (e.messageType === MessageType.close) {
            this.dqoiItem = null;
            this.restoreScrollPosition();
            //_.remove(this.dqoiItems, function (n: DQOIItem) {
            //    return n.index === index;
            //});

            //  this.cd.detectChanges();
        }
        if (e.messageType === MessageType.childSaved) {

            this.getSingleData(e.messageData);
        }

    }
    PopulateZeros(data) {
        //data.forEach((row) => {
        //    let staticColumns: any = ['contractId', 'customerId', 'customerName', 'locationName', 'locationId', 'dispatchNumber', 'receivedDateTime', 'estimatedEndDate', 'estimatedBeginDate', 'contractNote',
        //        'contractAdminId', 'dispatchStatusId', 'accountClassId', 'certPayrollRequired', 'drawDateInfo', 'dispatchReason', 'profitDollars', 'profitPercent', 'totalCostPlusTax', 'mostRecentDrawCost',
        //        'divisionName', 'co', 'pm', 'pmid', 'dynamicJobWipId', 'dateExecuted', 'contractAdministrator'];
        //    if () {

        //    }
        //});
        data.forEach((row) => {
            this.aggregates.forEach((agg) => {
                if (!row[agg.field]) {
                    row[agg.field] = 0;
                }
            });
            //if (!row.RefProfitDollars) {
            //    row.RefProfitDollars = 4;
            //}
            //if (row.findIndex((column) => { return column === "RefProfitDollars" }) == -1) {
            //    row.push({ RefProfitDollars: 2});
            //}
        });
        return data;
    }

    public updateDateData(data) {
        var iter = function (columns, record) {
            let keys = Object.keys(record);
            keys.forEach((key) => {

                if (columns.findIndex((column) => { return column.field === key; }) == -1) {

                    //let columnSettings: ColumnSetting = {
                    //    field: key,
                    //    title: key,
                    //    format: 'c2',
                    //    type: 'text',
                    //    hidden: false
                    //};
                    //columns.push(columnSettings);

                    //datePipe.transform(Date.now(), 'yyyy-MM-dd');

                }
            });

            return columns;
        };

        return data.reduce(iter, []);
    }

    public getColumnHiddenStatus(column: string) {
        let hidden: boolean = false;
        switch (column) {
            case ("contractId"):
            case ("customerId"):
            case ("locationId"):
            case ("contractAdminId"):
            case ("dispatchStatusId"):
            case ("accountClassId"):
            case ("pmid"):
            case ("dynamicJobWipId"):
            case ("dateExecuted"):
                {
                    hidden = true;
                    break;
                }
            case ("estimatedCost"):
            case ("RefCostPlusTax"):
            case ("RefProfitDollars"):
            case ("RefProfitPercent"):
            case ("CarCostPlusTax"):
            case ("CarProfitDollars"):
            case ("CarProfitPercent"):
            case ("ManCostPlusTax"):
            case ("ManProfitDollars"):
            case ("ManProfitPercent"):
            case ("EleCostPlusTax"):
            case ("EleProfitDollars"):
            case ("EleProfitPercent"):
                {
                    hidden = true;
                    break;
                }
            default:
                hidden = false;
        }
        return hidden;
    }

    public setColumnHiddenStatus() {
        this.ColumnHeaders.forEach((column) => {
            switch (column.title) {
                case ("contractId" || "customerId" || "locationId" || "contractAdminId" || "dispatchStatusId" || "accountClassId" || "pmid" || "dynamicJobWipId" || "dateExecuted"):
                    column.hidden = true;
                    break;
                default:
                    column.hidden = false;
            }
        });

    }

    public getColumnFormatStyle(column: string) {
        let format: any;
        switch (column) {
            case ("contractId"):
            case ("customerId"):
            case ("locationId"):
            case ("contractAdminId"):
            case ("dispatchStatusId"):
            case ("accountClassId"):
            case ("pmid"):
            case ("dynamicJobWipId"):
            case ("dateExecuted"):
                format = '';
                break;
            case ("locationName"):
            case ("dispatchNumber"):
            case ("contractNote"):
            case ("certPayrollRequired"):
            case ("dispatchReason"):
            case ("divisionName"):
            case ("co"):
            case ("pm"):
                format = '';
                break;
            case ("receivedDateTime"):
            case ("estimatedEndDate"):
            case ("estimatedBeginDate"):
            case ("jobWarrantyEndDate"):
            case ("lastDayLaborStartDate"):
            case ("drawDateInfo"):
                format = { date: 'short' };
                break;
            case ("Labor"):
            case ("profitDollars"):
            case ("totalCostPlusTax"):
            case ("mostRecentDrawCost"):
                format = 'c2';
                break;
            case ("profitPercent"):
                format = 'p2';
                break;
            default:
                format = 'c2';
        }

        return format;
    }

    public expandDetail() {
        return true;
    }
    rowClassFunction(context: RowClassArgs) {
        let data: any = context.dataItem;
        let rowClass = {};
        if (data.dispatchStatusId == "57e24f4b-a4f4-41ee-969f-a441554feaf4") {
        }
        switch (data.dispatchStatusId.toString()) {
            case "57e24f4b-a4f4-41ee-969f-a441554feaf4": //In Progress
                rowClass = { inprogress: true };
                break;
            case "9168c82b-a790-4423-90fe-8514cc653bf3": //Off Site
                rowClass = { offsite: true };
                break;
            case "d69f143d-36e8-47f3-a596-c570bbd02cf0": //Billed
                rowClass = { billed: true };
                break;
            case "76a083bc-0061-4473-a6f0-ce5081f4f8da": //Closed
                rowClass = { closed: true };
                break;
            default:
            // code block
        }
        return rowClass;
    }
    //public expandedDetailKeys: any[] = [1];

    //public expandDetailsBy = (dataItem: any): any => {
    //    return dataItem.ProductID;
    //}

    testColumns: any = ["contractId", "Labor", "customerId", "locationName", "locationId", "dispatchNumber",
        "receivedDateTime", "estimatedEndDate", "estimatedBeginDate", "jobWarrantyEndDate", "lastDayLaborStartDate", "contractNote", "contractAdminId", "dispatchStatusId",
        "accountClassId", "certPayrollRequired", "drawDateInfo", "dispatchReason", "profitDollars", "profitPercent", "totalCostPlusTax",
        "mostRecentDrawCost", "divisionName", "co", "pm", "pmid", "dynamicJobWipId", "dateExecuted", "Material", "Other", "Warranty",
        "OrderCost", "BilledEquip", "BilledNoEquip", "ChangeOrders", "BidEquipCost", "BidEquipSale", "VendorCredit", "VendCredOther", "MfgWarranty", "CreditCards"];

    DefaultColumnOrder: any = [
        { header: 'pm', order: 0 },
        { header: 'contractAdminId', order: 1 },
        { header: 'customerId', order: 2 },
        { header: 'locationName', order: 3 },
        { header: 'dispatchReason', order: 4 },
        { header: 'dispatchNumber', order: 5 },
        { header: 'estimatedBeginDate', order: 6 },
        { header: 'estimatedEndDate', order: 7 },
        { header: 'jobWarrantyEndDate', order: 8 },
        { header: 'lastDayLaborStartDate', order: 9 },
        { header: 'pm', order: 10 },
        { header: 'pm', order: 11 },
        { header: 'pm', order: 12 },
        { header: 'pm', order: 13 }
    ];
    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.processGridData();
    }
    public filter: CompositeFilterDescriptor;
    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }
    public exportGridToExcel(): void {

        this.grid.saveAsExcel();
    }
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.exportFilteredData) this.exportFilteredData = [];
        const result: ExcelExportData = {
            data: process(this.exportFilteredData as any, {}).data,
        };
        return result;
    }

    public get splitterSize(): string {
        return this._splitterSize;
    }
    public set splitterSize(newSize: string) {
        this._splitterSize = newSize;
        localStorage.setItem("sidebarSize", newSize);
    }

}
